import React, {useContext, useEffect, useState} from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import { useSanctum, withSanctum, SanctumContext } from "react-sanctum";
import {authLocalStorage} from "../../config/global";
import {useAuthLocalStorage} from '../../hooks/useAuthLocalStorage';

const RestrictedRoute = (props: any) => {
    /*const { authenticated, user, checkAuthentication } = useSanctum();
   const navigate = useNavigate();

   useEffect(() => {
       checkAuthentication()
           .then(() =>{
               console.log('RestrictedRoute - check auth: ' + authenticated);
               navigate('/');
           });
   });



      useEffect(() => {
          checkAuthentication()
              .then(() =>{
                  console.log('RestrictedRoute - check auth: ' + authenticated);
                  setAuth(authenticated);
                  navigate('/');
              });


          if(!is_auth)
              setAuth(localStorage.getItem("auth") === 'true')

          console.log('RestrictedRoute - useEffect-is_auth: ' + is_auth);

      });





   const [is_auth, setAuth] = useState<boolean|null>(false);
   useEffect(() => {
       const auth = JSON.parse(localStorage.getItem('signedIn') || 'false');
       if (auth) {
           console.log('RestrictedRoute - useEffect - local storage auth: ' + auth)
       }

       setAuth(auth === 'true');
   });

   //const [_auth] = useState<boolean|null>(JSON.parse(localStorage.getItem(authKey) || 'false') as boolean);

   const [is_auth, setAuth] = useState<boolean|null>(JSON.parse(localStorage.getItem(authLocalStorage.authKey) || 'false') as boolean);
   useEffect(() => {
       setAuth(JSON.parse(localStorage.getItem(authLocalStorage.authKey) || 'false') as boolean);
   });
*/

    //console.log('RestrictedRoute - sanctum authenticated: ' + authenticated);
    //console.log('RestrictedRoute - sanctum user: ' + user);

    //console.log('RestrictedRoute - from storage - is_auth: ' + JSON.parse(localStorage.getItem('signedIn') || 'false'));
 /*   console.log('RestrictedRoute - is_auth: ' + is_auth);


    if(is_auth)
        console.log('if del cazzo!: ' + is_auth);


    return (is_auth) ? <Outlet /> : <Navigate to="/landing" />;
*/
    //const {authenticated} = useContext(SanctumContext);

    const {getAuthLocalStorageKey} = useAuthLocalStorage();
    //console.log('RestrictedRoute - authLocalStorageSigned: ' + getAuthLocalStorageKey());


    return (getAuthLocalStorageKey()) ? <Outlet /> : <Navigate to="/landing" />;
}

export default RestrictedRoute;
